import { forwardRef } from 'react';

import Icon, { IconProps } from '../Icon';

export const UploadIcon = forwardRef<SVGSVGElement, IconProps>((props, ref) => (
  <Icon ref={ref} viewBox="0 0 24 24" fill="currentColor" {...props}>
    <path d="M11.2 4.42a6 6 0 0 0-6.5 9.78 1 1 0 0 1-1.42 1.4A8 8 0 1 1 16.42 7h1.08a5.5 5.5 0 0 1 3.06 10.07 1 1 0 0 1-1.12-1.66A3.5 3.5 0 0 0 17.5 9h-1.79a1 1 0 0 1-.96-.71 6 6 0 0 0-3.55-3.87Z" />
    <path d="m13 14.41 2.3 2.3a1 1 0 0 0 1.4-1.42l-4-4a1 1 0 0 0-1.4 0l-4 4a1 1 0 1 0 1.4 1.42l2.3-2.3V21a1 1 0 1 0 2 0v-6.59Z" />
  </Icon>
));
export default UploadIcon;
